import { object, string } from 'yup'

export const LLENADO_SCHEMA = object().shape({
  cereal: string().required('El campo es requerido').typeError('El campo debe ser texto').max(8, 'Maximo de 8 caracteres'),
  variedad: string().required('El campo es requerido').typeError('El campo debe ser texto').max(8, 'Maximo de 8 caracteres'),
  etiqueta: string().typeError('El campo debe ser texto').notRequired(),
  color: string().typeError('El campo debe ser texto').notRequired()
})

export const MODIFICAR_LLENADO_SCHEMA = object().shape({
  etiqueta: string().typeError('El campo debe ser texto').notRequired(),
  color: string().typeError('El campo debe ser texto').notRequired()
})

export const FILTRADO_SCHEMA = object().shape({
  cereal: string().required('El campo es requerido').typeError('El campo debe ser texto').max(8, 'Maximo de 8 caracteres'),
  variedad: string().required('El campo es requerido').typeError('El campo debe ser texto').max(8, 'Maximo de 8 caracteres')
})
